module.exports = __webpack_public_path__ + "img/if_8.a535b4bd.png";